import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { Button } from "./Button";

export function SuggestionMark({ className }) {
  return <span aria-label="Suggested" className={cn("inline-flex items-center justify-center w-4 h-4 rounded-chip bg-suggest-bg text-suggest font-display font-semibold text-[10px] leading-none", className)}>S</span>;
}

// variants: field · link (Group / 1:1) · nextAction · docType · bulk (checkbox). Accept (Enter) outline-strong; low confidence → Edit is strong, why starts with "Possibly"
export function SuggestionRow({ kind, what, why, confidence = 1, acceptLabel = "Accept", variant = "field", checked, onCheck, onAccept, onEdit, onSkip, onNotThis, selected = false, state, className, testid }) {
  const [reason, setReason] = useState(null);
  const low = confidence < 0.6;
  const strong = low ? "edit" : "accept";
  return (
    <div data-testid={testid || "suggestion-row"} className={cn("flex items-start gap-3 py-2 px-3 border-b border-hairline font-ui text-ui-sm transition-colors duration-120", selected && "bg-accent shadow-[inset_2px_0_0_hsl(var(--primary))]", className)}>
      {variant === "bulk" && <input type="checkbox" checked={!!checked} onChange={(e) => onCheck?.(e.target.checked)} className="mt-1 accent-[hsl(var(--primary))] w-4 h-4" data-testid={testid && `${testid}-check`} />}
      <SuggestionMark className="mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="text-foreground truncate"><span className="text-muted-foreground">{kind}</span>{kind ? " · " : ""}{what}</div>
        {why && <div className="text-ui-xs text-muted-foreground truncate">{low && !/^possibly/i.test(why) ? "Possibly " : ""}{why}</div>}
        {reason === "ask" && (
          <div className="flex gap-1.5 mt-1" data-testid={testid && `${testid}-why`}>
            {["wrong case", "wrong value", "already done"].map((r) => <button key={r} onClick={() => { setReason(r); onNotThis?.(r); }} className="rounded-chip border border-border px-2 h-ctl-sm text-ui-xs hover:bg-muted">{r}</button>)}
          </div>
        )}
        {state && <div className="text-ui-xs text-muted-foreground mt-0.5">{state}</div>}
      </div>
      {!state && (
        <div className="flex items-center gap-1 flex-shrink-0">
          <Button size="sm" variant={strong === "accept" || selected ? "outline-strong" : "secondary"} onClick={onAccept} data-testid={testid && `${testid}-accept`}>{acceptLabel}</Button>
          {onEdit && <Button size="sm" variant={strong === "edit" && !selected ? "outline-strong" : "secondary"} onClick={onEdit} data-testid={testid && `${testid}-edit`}>Edit</Button>}
          <Button size="sm" variant="ghost" onClick={onSkip} title="Skip for 7 days" data-testid={testid && `${testid}-skip`}>Skip</Button>
          <Button size="sm" variant="ghost" onClick={() => setReason("ask")} data-testid={testid && `${testid}-notthis`}>Not this</Button>
        </div>
      )}
    </div>
  );
}
